import { render } from "./Logo.vue?vue&type=template&id=6206dcbc"
const script = {}

import exportComponent from "/storage/xmaisdigital/digloja-admin/releases/71/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__